module.exports = __webpack_public_path__ + "static/media/500-background.c1308eb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/500-background.svg
// module id = 345
// module chunks = 13